"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const EditProjectForm_1 = __importDefault(require("./EditProjectForm"));
exports.default = EditProjectForm_1.default;
